<template>
    <div>
      <!-- 新增字段输入框和按钮 -->
      
     <el-button type="primary" @click="newfieldbox = true">计算数据</el-button>
     <el-dialog title="自定义计算数据" v-model="newfieldbox" width="600" :before-close="dialogBeforeClose">
         <div class="dialog-body">
            <el-button type="primary" @click="addnewfieldbox = true">新增自定义计算</el-button>
            <el-dialog
                v-model="addnewfieldbox"
                width="600"
                title="新增自定义计算"
                append-to-body
                >
               <div class="addnewfield">
                  <el-input v-model="calculation_result" placeholder="结果名称" width="100%" style="margin-bottom: 20px;"></el-input>
                  <el-card style="width: 48%;">
                    <template #header>
                        <div class="card-header">
                            <span>可用字段</span>
                        </div>
                    </template>
                     <div class="zd">
                         <p class="p1" v-for="(item,index) in newFieldName" :key="index" @click="calculation_formula += '{'+item+'}'">{{ item }}</p>
                     </div>
                  </el-card>
                  <el-card style="width: 48%;">
                    <template #header>
                        <div class="card-header">
                            <span>计算公式</span>
                        </div>
                    </template>
                        <div class="zd">
                        <el-input type="textarea" v-model="calculation_formula" placeholder="计算公式，字段名请点击右边可用字段" resize="none" input-style="height:100%"></el-input>
                        </div>
                  </el-card>
               </div>
               <template #footer>
                    <el-button @click="addnewfieldbox = false">取 消</el-button>

                    <el-button @click="checkjs()">校验公式</el-button>
                    <el-button type="primary" @click="addjsgs">确 定</el-button>
                </template>
            </el-dialog>
            <el-table :data="jsData" style="width: 100%" height="350">
                
                <el-table-column prop="calculation_result" label="计算结果" width="100"></el-table-column>
                <el-table-column prop="calculation_formula" label="计算公式" width="180"></el-table-column>
                <el-table-column prop="data_key" label="字段名" width="180"></el-table-column>
                <el-table-column fixed="right" label="操作" min-width="150">
                    <template #default="scope">
                        <el-button link type="primary" size="small" @click="removenewfiel(scope.row.id,scope.row.user_id, scope.row.data_key)">
                        删除
                        </el-button>
                        <el-button link type="primary" size="small" @click="savejsdata(scope.row.user_id, scope.row.calculation_formula,scope.row.js_key,scope.row.calculation_result,scope.row.data_key)" v-if="!scope.row.id">
                        保存到数据库
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
         </div>
         <template #footer>
             <el-button type="primary" @click="newfieldbox = false">关 闭</el-button>
         </template>
     </el-dialog>
      <!-- ElementPlus 表格 -->
      <el-table :data="tableData" style="width: 100%">
        <!-- 动态生成表头和列 -->
        <el-table-column
          v-for="(column, index) in tableColumns"
          :key="index"
          :prop="column.columnName"
          :label="column.columnComment"
        >
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script setup>
  import {getTableColumns,getJsdata,getData,removeJSdata,saveJsdata} from '../../api/userMG'
  import { ref ,onBeforeMount} from 'vue';
  import { ElNotification } from 'element-plus';
  import { pinyin } from 'pinyin-pro';

  const newfieldbox = ref(false);
  const addnewfieldbox = ref(false);
  const gsjy = ref(false);
  // 定义新字段名的响应式变量
  const jsData = ref([]);

  const newFieldName = ref([]);
  const calculation_result = ref('');
  const calculation_formula = ref('');
  const commentToColumn = {};
  // 定义表格数据 从后端动态获取表格数据
// 假设这是从数据根据用户ID 获取到的计算公式表
  const tableData = ref([]);
  const fieldMap = new Map();

  // 定义表格列
  const tableColumns = ref([]);


 const newData = ref( {

    calculation_result: '',
    calculation_formula: '',
    data_key: '',
    js_key:'',
user_id:1})

const savejsdata =(user_id,calculation_formula,js_key,calculation_result,data_key)=>{
    saveJsdata({user_id:user_id,calculation_formula:calculation_formula,js_key:js_key,calculation_result:calculation_result,data_key:data_key}).then(res=>{
        if(res.status==200){
            ElNotification({
                title: 'Success',
                message: '保存成功',
                type: 'success',
            });
        }
      
    })
}

  const dialogBeforeClose = () => {
    newfieldbox.value = false;
  };
  const removenewfiel = (id,user_id,data_key) =>{
   if(id){
    removeJSdata({id:id,user_id:user_id,data_key:data_key}).then(res=>{ 
        if(res.status == 200){

            jsData.value = jsData.value.filter(item => item.id !== id);
            tableData.value.forEach(item => {
                    delete item[data_key];
                });
            tableColumns.value = tableColumns.value.filter(item => item.columnName !== data_key);
            ElNotification({
                title: 'Success',
                message: '删除成功',
                type: 'success',
            });
        }else{
            ElNotification({
                title: 'Error',
                message: '删除失败',
                type: 'error',
            });
        }
    })
   }else{
    jsData.value = jsData.value.filter(item => item.id !== id);
            tableData.value.forEach(item => {
                    delete item[data_key];
                });
            tableColumns.value = tableColumns.value.filter(item => item.columnName !== data_key);
            ElNotification({
                title: 'Success',
                message: '删除成功',
                type: 'success',
            });
   }


}

const addjsgs = () =>{
    if(!calculation_result.value){
        ElNotification({
        title: 'Error',
        message: '请输入结果名称',
        type: 'error',
        });
        return;
    }
   if(gsjy.value){

     newData.value.calculation_result=calculation_result.value,
     newData.value.calculation_formula=calculation_formula.value,
     newData.value.data_key=pinyin(calculation_result.value, {
        toneType: 'none', // 无音调风格
        type: 'string', // 返回字符串类型
        v: true,
        separator: '' // 拼音之间的分隔符
        })
      

      const newtablename= {

        columnName: newData.value.data_key,
        dataType: 'varchar(255)',
        columnComment: calculation_result.value,
      };


      tableColumns.value.push(newtablename);
      
      jsData.value.push(newData.value);


      tableData.value.forEach(item => {
      
        // 替换表达式中的占位符

        let expression = calculation_formula.value;
        for (const [comment, column] of Object.entries(commentToColumn)) {
            const placeholder = `{${comment}}`;
            // 创建一个全局匹配的正则表达式
            const regex = new RegExp(placeholder, 'g');
        if (expression.includes(placeholder)) {
            expression = expression.replace(regex, item[column]);
           
        }
        }


        try {
        // 尝试计算表达式
    
         let res=eval(expression)
         if (Number.isInteger(res)) {
            item[newData.value.data_key]=res;
            } else {
                // 若为小数，保留两位小数
                item[newData.value.data_key]=parseFloat(res.toFixed(2));
            }
        } catch (error) {
      
        item[newData.value.data_key]=''
        }
   
      });
      calculation_result.value = '';
      calculation_formula.value = '';
      addnewfieldbox.value = false;
      ElNotification({
        title: 'Success',
        message: '新增成功',
        type: 'success',
      });
    }else{
      ElNotification({
        title: 'Error',
       message: '请先校验公式',
      })
    }
 
}
    const checkjs = () =>{
   
       
  

        // 提取数据
        const data = tableData.value[0];
        // 替换表达式中的占位符
        let expression = calculation_formula.value;
        let expression2 = calculation_formula.value;
        for (const [comment, column] of Object.entries(commentToColumn)) {
            const placeholder = `{${comment}}`;
         
            // 创建一个全局匹配的正则表达式
            const regex = new RegExp(placeholder, 'g');
            if (expression.includes(placeholder)) {
                expression = expression.replace(regex, data[column]);
            }
            if (expression2.includes(placeholder)) {
                expression2 = expression2.replace(regex, '{'+column+'}');
            }
        }
        newData.value.js_key=expression2
      
        const result = ref(null);
        try {
        // 尝试计算表达式
        result.value = eval(expression);
        } catch (error) {
        // 若计算过程中出现错误，将结果设为 false
        result.value = false;
        }
       if (result.value) {
     
        ElNotification({
            title: 'OK',
            message: '公式校验通过',
            type: 'success',
        });
        gsjy.value = true;
       }else{
        ElNotification({
            title: 'Error',
            message: '校验失败，请检查公式',
            type: 'error',
        });
        gsjy.value = false;
       }
  }

// 获取表头信息
const gettablecolumns = async (find) => {
  return new Promise((resolve, reject) => {
    getTableColumns(find)
    .then(res => {
      if (res.status === 200) {
        const d = res.data.list;
        d.forEach(item => {
          tableColumns.value.push({
            columnName: item.name,
            columnComment: item.comment,
            dataType: item.type
          });
        });
        tableColumns.value.forEach(item => {
          commentToColumn[item.columnComment] = item.columnName;
          if (
            item.columnName!== 'id' &&
            item.columnName!== 'user_id' &&
            (item.dataType.includes('int') || item.dataType.includes('float'))
          ) {
            newFieldName.value.push(item.columnComment);
          }
        });
        resolve();
      } else {
        reject(new Error('获取表头信息失败'));
      }
    })
    .catch(error => {
      console.error('获取表头信息出错:', error);
      reject(error);
    });
  });
};

// 获取 js 数据
const getjsdata = async (find) => {
  return new Promise((resolve, reject) => {
    getJsdata(find)
    .then(res => {
      if (res.status === 200) {
        jsData.value = res.data.list;
        jsData.value.forEach(item2 => {
          const newColumn = {
            columnName: item2.data_key,
            dataType: 'varchar(255)',
            columnComment: item2.calculation_result
          };
          tableColumns.value.push(newColumn);
        });
        resolve();
      } else {
        reject(new Error('获取 js 数据失败'));
      }
    })
    .catch(error => {
      console.error('获取 js 数据出错:', error);
      reject(error);
    });
  });
};

// 获取数据
const getdata = async (find) => {
  try {
    const res = await getData(find);
    if (res.status === 200) {
      tableData.value = res.data.list;
    }
  } catch (error) {
    console.error('获取数据出错:', error);
    throw error;
  }
};

onBeforeMount(async () => {
  try {
    // 先获取表头信息
    await gettablecolumns({ tn: 'data_prodata' });
    // 再获取 js 数据
    await getjsdata({ user_id: '1' });
    // 最后获取数据
    await getdata({ user_id: '1', tn: 'data_prodata' });

    // 遍历 tableData 和 jsData
    tableData.value.forEach(item => {
      jsData.value.forEach(item2 => {
        const key = `${item.id}-${item2.data_key}`;
        // 从 fieldMap 中查找对应的值
        if (fieldMap.has(key)) {
          item[item2.data_key] = fieldMap.get(key);
        }
      });
    });
  } catch (error) {
    console.error('初始化数据出错:', error);
  }
});

  // 新增字段的方法

  </script>
  <style scoped>
.addnewfield{    display: flex
;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;}
.addnewfield .el-card{--el-card-padding: 10px;}
.addnewfield .card-header{}
.addnewfield .zd{width: 100%;
    display: flex
;
    flex-direction: column;
    justify-content: flex-start;
    height: 300px;
    overflow-y: auto;}
.addnewfield .zd .p1{margin: 15px 0 0 0; cursor: pointer;}
.addnewfield .zd .zinput{}
.addnewfield .zd .el-textarea{height: 100%;}
</style>